import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef } from 'react';
import '../../styles/game/BetControls.css';
// src/socket.js
import { io } from "socket.io-client";
import { useSocket } from '../../providers/SocketContext.jsx'
import { useAuth } from '../../providers/AuthProvider.jsx';
// const socketUrl = "http://91.186.196.251:8081/";
// const socket = io(socketUrl, {
//     reconnection: true,           // Включить автоматическое переподключение
//     reconnectionAttempts: 5,      // Максимальное количество попыток переподключения
//     reconnectionDelay: 3000,      // Задержка между попытками переподключения
//     reconnectionDelayMax: 5000,   // Максимальная задержка между попытками
//     timeout: 10000,               // Время ожидания подключения
// });




function BetControl2Hand({ isUserBalance, setIsUserBalance, doubleBet, setDoubleBet, userWallet, setDisconnect, setIsNotifyOpen }) {
    const { t } = useTranslation();
    const socket = useSocket();
    const [value, setValue] = useState(1000.00);
    const [betValue, setBetValue] = useState(value);
    const [autoBet, setAutoBet] = useState(false);
    const [autoCashout, setAutoCashout] = useState(false);
    const [betController, setBetController] = useState(true);
    const [autoBetController, setAutoBetController] = useState(false);
    const betControllerSwitcher = useRef(null);
    const [betOption, setBetOption] = useState(null)
    

    const [isUserId, setIsUserId] = useState(null);
    const [isAviatorId, setIsAviatorId] = useState(null);
    const [isAvatarUrl, setIsAvatarUrl] = useState(null);
    const [firstDeposit, setFirstDeposit] = useState(false);

    const { user } = useAuth()
    useEffect(() => {
        setBetValue(value)
    }, [value])



    useEffect(() => {
        if(!user) {
            return
        }

        setIsUserId(user.id)
        setIsAviatorId(user.aviatorId)
        setIsAvatarUrl(user.userAvatarUrl)
        setFirstDeposit(user.firstDeposit)
    }, [user])

    useEffect(() => {
        if (!socket) return;
        // Обработка переподключения
socket.on('connect', () => {

    console.log('Подключено к серверу');
});

socket.on('disconnect', (reason) => {
    console.log(`Отключено от сервера: ${reason}`);
    setDisconnect(true)
});

socket.on('reconnection', (attemptNumber) => {
    console.log(`Переподключено после ${attemptNumber} попыток`);
});

socket.on('reconnect', (attemptNumber) => {
    console.log(`Успешное переподключение после ${attemptNumber} попыток`);
});

socket.on('connect_error', (error) => {
    console.log('Ошибка подключения:', error.message);
});



return () => { 
    socket.disconnect();
};
    }, [socket])
    

    function autoBetActive() {
        if(autoBetController) {
            return
        }
        
            
            setAutoBetController(true)
            setBetController(false);
        

    }

    function betControllerActive() {
        if (betController) {
            return
        }
        
            setAutoBetController(false)
            setBetController(true);
        
    }



    useEffect(() => {
        if (!socket) return;
    
        const handleCashOutMessage = (res, hand) => {
            if(hand === 'second') {
                const profit = parseFloat(res);

                setIsUserBalance((prev) => {
                    const result = parseFloat(prev) + parseFloat(profit);
                    return result;
                });
            }
        };
    
        const handleStartScene = (res) => {
            if(res.message === 'second') {
                setBetState('betActive')
            }
        };
    
        const handleFlewAway = (res) => {
            if (res.message === 'second') {
                if (autoBet) {
                    setBetState('waitingRound');
                } else {
                    setBetState('bet');
                }
            }
        };
    
        const handleCountdownStart = (res) => {

            if(res.message === 'second') {
                setBetState('countdown');
                setIsUserBalance((prev) => {
                    console.log(typeof prev + ' тип в countdown' + '  ' + prev);
                    const result = parseFloat(prev) - parseFloat(betValue);
                    return result;
                });
            }
        };
    
        const handleQueueMessage = (res) => {
            console.log(res);
        };
    
        // Подписываемся на события
        socket.on('cash_out_message', handleCashOutMessage);
        socket.on('start_scene', handleStartScene);
        socket.on('flew_away', handleFlewAway);
        socket.on('countdown_start', handleCountdownStart);
        socket.on('queueMessage', handleQueueMessage);
    
        // Очищаем подписки перед повторной установкой
        return () => {
            socket.off('cash_out_message', handleCashOutMessage);
            socket.off('start_scene', handleStartScene);
            socket.off('flew_away', handleFlewAway);
            socket.off('countdown_start', handleCountdownStart);
            socket.off('queueMessage', handleQueueMessage);
        };
    }, [socket, betValue, autoBet]); // Добавляем зависимости


    // Сохраняем состояние в localStorage при его изменении
    useEffect(() => {
        localStorage.setItem("doubleBet", JSON.stringify(doubleBet));
    }, [doubleBet]);

    const handleChange = (event) => {
        const input = event.target.value;

        // Разрешаем только цифры, запятые и точки
        if (/^\d*\.?\d*$/.test(input)) {
            setValue(input); // Обновляем состояние, если ввод допустим
        }
    };

    useEffect(() => {
        if(value) {
            if(betValue < 1000) {
                setValue(1000)
            }
        }
    }, [betValue])

    const handleBlur = () => {
        const numericValue = parseFloat(value);
        if (!isNaN(numericValue)) {
            const formattedValue = parseFloat(numericValue.toFixed(2));
            if(formattedValue > 3000000.00) {
                setValue(3000000.00)
                setBetValue(3000000.00)
            } else {
                setValue(formattedValue); // Устанавливаем форматированное значение
                setBetValue(formattedValue);
            }
        }
    };

    const handleMinus = () => {
        const newValue = parseFloat((parseFloat(value) - 1000).toFixed(2));
        if (newValue >= 1000) { // Не позволяем уйти в отрицательные числа
            setValue(newValue);
            setBetValue(newValue);
        }
    };

    const handlePlus = () => {
        const newValue = parseFloat((parseFloat(value) + 1000).toFixed(2));
        if (newValue <= 3000000) { // Не позволяем уйти в отрицательные числа
            setValue(newValue);
            setBetValue(newValue);
        }
    };


    const [betState, setBetState] = useState('bet');


    function cancelBet() {
        const socketId = socket.id;
        socket.emit("leaveQueue", { socketId, hand: 'second' });
        setBetState('bet')
    }



    

    function BetActive() {
        const [betResult, setBetResult] = useState(1);
        useEffect(()=> {
            socket.on('data', (res) => {
                const resValue = parseFloat(res.value);
                if(parseFloat(resValue) > 30000) {
                    setBetResult(30000)
                } else {
                    setBetResult(resValue)
                }
            })
        },[])
        const cashoutData = {
            cashout: betResult,
            userId: isUserId,
            socketId: socket.id,
            hand: 'first',
        }
        return (
            <>
                <button className={'bet-btn betActive'} onClick={() => {
                    socket.emit('cash_out', cashoutData)
                    if(autoBet) {
                        setBetState('waitingRound')
                    } else {
                        setBetState('bet');
                    }
                    
                }}>
                    <span>{t("cash_out")}</span>
                        <div className={'d-flex amount-container'}>
                            <span
                                style={{fontSize: "22px", "lineHeight": "27px"}}>{parseFloat(betValue * betResult) < 30000 ? parseFloat(betValue * betResult).toFixed(2) : "30,000.00"}</span>
                                <span className={'bet-control-currency'}>USD</span>
                        </div>
                </button>                
            </>
        )
    }




    function Countdown() {
        const betValueRef = useRef(betValue)

        useEffect(() => {
            betValueRef.current = betValue;
        }, [betValue])
        return (
            <>
                <button className={'waitingBtn height-100'} onClick={() => {
                    cancelBet()
                    setIsUserBalance((prev) => {
                        const result = parseFloat(prev) + parseFloat(betValueRef.current)
                        return result
                    })
                    
                }}>
                    
                        <div className={'d-flex amount-container'}>
                        {t("bet_control_cancel")}
                        </div>
                </button>                     
            </>
        )
    }

    function WaitingRoundBtn() {

        
        return (
            <>
                
                <button className={'waitingBtn'} onClick={() => {
                    cancelBet()
                    setBetState('bet');
                    
                }}>
                    
                        <div className={'d-flex amount-container'}>
                            {t("bet_control_cancel")}
                        </div>
                        <div className={'waitingBtn-text'}>{t("bet_control_waiting_for_next_round")}</div>
                </button>           
            </>
        )
    }

    function BetButtonBlock() {
        const betValueRef = useRef(betValue)

        useEffect(() => {
            betValueRef.current = betValue;
        }, [betValue])

        return (
            <>
                <button className={'bet-btn'} onClick={() => {
                    if(isUserBalance) {
                        if(parseFloat(isUserBalance) < parseFloat(betValue)) {
                            setIsNotifyOpen(true)
                            return
                        } else {
                            setBetState('waitingRound')
                        }
                    }
                }}>
                    <span>{t("betControlBet")}</span>
                    <div className={'d-flex amount-container'}>
                        <span
                            style={{ fontSize: "22px", lineHeight: "27px" }}>
                            {typeof betValueRef.current === "number"
                            ? new Intl.NumberFormat('en-US', {
                                style: 'decimal',
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            }).format(betValueRef.current)
                            : betValueRef.current}
                        </span>
                                <span className={'bet-control-currency'}>UZS</span>
                        </div>
                </button>
            </>
        )
    }

    function reqStatus() {
        const data = 'privet'
        if (socket) {
            socket.emit('req_queue', data)
        }
    }

    useEffect(() => {
        if (!socket) {
            return;
        }
    
        const handleResQueue = (result, hand) => {
            
            if(hand === 'second') {
                if (result === 'countdown') {
                    setBetState('countdown');
                    setIsUserBalance((prev) => {
                        const result = parseFloat(prev) - parseFloat(betValue); // Текущее значение betValue
                        return result;
                    });
                }
            }
        };
    
        // Сначала отписываемся, чтобы избежать дублирования
        socket.off('res_queue', handleResQueue);
        socket.on('res_queue', handleResQueue);
    
        return () => {
            socket.off('res_queue', handleResQueue); // Отписываемся при размонтировании
        };
    }, [socket, betValue]);
    // socket.on('gameState', (result) => {
        
    //     if (betState === 'waitingRound') {
    //         console.log('gameState socket')
    //         if(result === 'countdown') {
    //             setBetState('countdown')
    //         }
    //     }
    // })
    useEffect(() => {
        if (!socket) {
            return
        }
        function reqStatus(isUserBalance) {
            if(isUserBalance) {
                if (parseFloat(isUserBalance) < parseFloat(betValue)) {
                    return
                }
            }
            if (socket) {
                const socketId = socket.id
                const req = {
                    socketId: socketId,
                    bet: parseFloat(betValue).toFixed(2),
                    userId: isUserId,
                    aviatorId: isAviatorId,
                    avatarUrl: isAvatarUrl,
                    cashout: 0,
                    hand: 'second',
                    currency: userWallet,
                }
                if(socketId) {
                    socket.emit('req_queue', (req))
                }
            }

            
        }
        // Проверка состояния и отправка запроса

        if (betState === "waitingRound") {
            reqStatus(isUserBalance);
        }

        // Очистка ресурса, если необходимо (опционально)

    }, [betState, socket]); // useEffect зависит от betState

    const [borderColor, setBorderColor] = useState('');
    useEffect(() => {
        
        if(betState === 'waitingRound' || betState === 'waitingStart') {
            setBorderColor('border-red');
        } else if (betState === 'betActive'){
            setBorderColor('border-orange')            
        } else {
            setBorderColor('');
        }
    }, [betState])

    function betOptButton(value) {
        if(betOption !== value) {
            setBetOption(value)
            setValue(value)
        } else if (betOption === value) {
            setValue((prev) => {
                const parse = parseFloat(prev)
                return parse + value;
            })
        }
    }

    return (
        <>
            
                <div className={`bet-control-container hidden ${doubleBet ? "double-bet visible pl-2" : ""}`}>
                    <div className={`bet-control ${borderColor}`}>
                    <div className={'bet-control-wrap'}>
                    <div className={'remove-hand-btn'} onClick={() => setDoubleBet(false)}></div>
                        <div className={'bet-nav-switcher-wrap'}>
                            <div className={`bet-nav-switcher ${autoCashout ? "disabled" : ""}`}>
                                {/* <div className={'nav-slider'} ref={betControllerSwitcher}></div> */}
                                <button className={`bet-switcher-tab ${betController ? "active" : ""}`} onClick={betControllerActive}>{t("betControlBet")}</button>
                                <button className={`bet-switcher-tab ${autoBetController ? "active" : ""}`} onClick={autoBetActive}>{t("betControlAuto")}</button>
                            </div>
                        </div>
                        <div className={`bet-block-container ${autoBetController ? 'margin' : ""}`}>
                            <div className={'bet-block'}>
                                <div className={'spinner-block'}>
                                    <div className={'amount-minus-btn'} onClick={() => setIsNotifyOpen(true)}></div>
                                    <div className={'amount-input-wrap'}>
                                        <input className={'amount-input'} type={'text'} inputMode={'decimal'}
                                               value={typeof value === "number" ? new Intl.NumberFormat('en-US', {
                                                style: 'decimal',
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              }).format(value) : value}
                                               onChange={handleChange} onBlur={handleBlur} onClick={() => setIsNotifyOpen(true)} />
                                    </div>
                                    <div className={'amount-plus-btn'} onClick={() => setIsNotifyOpen(true)}></div>
                                </div>
                                <div className={'bet-opt-list'}>
                                    <button className={'bet-opt-btn-first'} onClick={() => setIsNotifyOpen(true)}>
                                        <span style={{
                                            color: "#ffffff80",
                                            lineHeight: "1",
                                        }}>50,000.00</span>
                                    </button>
                                    <button className={'bet-opt-btn-first mt-4'} onClick={() => setIsNotifyOpen(true)}>
                                        <span style={{
                                            color: "#ffffff80",
                                            lineHeight: "1",
                                        }}>100,000.00</span>
                                    </button>
                                    <button className={'bet-opt-btn-first'} onClick={() => setIsNotifyOpen(true)}>
                                        <span style={{
                                            color: "#ffffff80",
                                            lineHeight: "1",
                                        }}>200,000.00</span>
                                    </button>
                                    {/* <button className={'bet-opt-btn-first mt-4'} onClick={() => betOptButton(10.00)}>
                                        <span style={{
                                            color: "#ffffff80",
                                            lineHeight: "1",
                                        }}>10.00</span>
                                    </button> */}
                                </div>
                            </div>
                            <div className={'bet-block-button-wrap'}>
                                {betState === 'bet' && <BetButtonBlock />}
                                {betState === 'waitingRound' && <WaitingRoundBtn />}
                                {betState === 'countdown' && <Countdown />}
                                {betState === 'betActive' && <BetActive />}


                            </div>
                            
                        </div>
                        </div>
                        <div className={`bet-controller-border-line ${autoBetController ? "" : "hidden"}`}></div>
                        <div className={`auto-bet-container ${autoBetController ? "" : "hidden"}`}>
                            <div className={'auto-bet-block'}>
                                <div className={'aut-bet-wrapper'}>
                                    {t("auto_bet")}
                                </div>
                                <div className={'um-switch'}>
                                    <div className={`um-input-switch ${autoBet ? "" : "off"}`} onClick={() => {
                                        if(firstDeposit) {
                                            setAutoBet(prev => !prev);
                                        } else {
                                            setIsNotifyOpen(true)
                                        }
                                    }}>
                                        <span className={'switch-oval'}></span>
                                    </div>
                                </div>
                            </div>
                            <div className={'cashout-block'}>
                                <div className={'cashout-switcher-wrapper'}>
                                    <div className={'auto-cashout-text'}>
                                        {t("auto_cash_out")}
                                    </div>
                                    <div className={'um-switch'}>
                                        <div className={`um-input-switch ${autoCashout ? "" : "off"}`} onClick={() => {
                                            if(firstDeposit) {
                                                setAutoCashout(prev => !prev);
                                            } else {
                                                setIsNotifyOpen(true)
                                            }
                                        }}>
                                            <span className={'switch-oval'}></span>
                                        </div>
                                    </div>
                                    <div className={'cashout-spinner-wrapper'}>
                                        <div className={'cashout-spinner'}>
                                            <div className={'cashout-input-wrapper'}>
                                                <input type={"text"} inputMode={'decimal'} disabled={""} value={"1.10"}/>
                                            </div>
                                            <span style={{
                                                padding: "0",
                                                fontSize: "16px",
                                                lineHeight: "1",
                                                color: "#fff",
                                                opacity: ".5",
                                                fontWeight: "700",
                                            }}>×</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

{/* 
                <div className={`bet-control-container hidden ${doubleBet ? "double-bet visible pl-5" : ""}`}>
                    <div className={'bet-control'}>
                        <div className={'remove-hand-btn'} onClick={() => setDoubleBet(false)}></div>
                        <div className={'bet-nav-switcher-wrap'}>
                        <div className={`bet-nav-switcher ${autoCashout2 ? "disabled" : ""}`}>
                                <div className={'nav-slider'} ref={betControllerSwitcher2}></div>
                                <button className={`bet-switcher-tab ${betController2 ? "active" : ""}`} onClick={betControllerActive2}>Bet</button>
                                <button className={`bet-switcher-tab ${autoBetController2 ? "active" : ""}`} onClick={autoBetActive2}>Auto</button>
                            </div>
                        </div>
                        <div className={'bet-block-container'}>
                            <div className={'bet-block'}>
                                <div className={'spinner-block'}>
                                    <div className={'amount-minus-btn'} onClick={handleMinus2}></div>
                                    <div className={'amount-input-wrap'}>
                                        <input className={'amount-input'} type={'text'} inputMode={'decimal'}
                                               value={typeof value2 === "number" ? value2.toFixed(2) : value2}
                                               onChange={handleChange2} onBlur={handleBlur2}/>
                                    </div>
                                    <div className={'amount-plus-btn'} onClick={handlePlus2}></div>
                                </div>
                                <div className={'bet-opt-list'}>
                                    <button className={'bet-opt-btn-first'}>
                                        <span style={{
                                            color: "#ffffff80",
                                            lineHeight: "1",
                                        }}>1.00</span>
                                    </button>
                                    <button className={'bet-opt-btn-first mt-4'}>
                                        <span style={{
                                            color: "#ffffff80",
                                            lineHeight: "1",
                                        }}>2.00</span>
                                    </button>
                                    <button className={'bet-opt-btn-first'}>
                                        <span style={{
                                            color: "#ffffff80",
                                            lineHeight: "1",
                                        }}>5.00</span>
                                    </button>
                                    <button className={'bet-opt-btn-first mt-4'}>
                                        <span style={{
                                            color: "#ffffff80",
                                            lineHeight: "1",
                                        }}>10.00</span>
                                    </button>
                                </div>
                            </div>
                            <div className={'bet-block-button-wrap'}>
                                <button className={'bet-btn'}>
                                    <span>BET</span>
                                    <div className={'d-flex amount-container'}>
                                        <span
                                            style={{fontSize: "24px"}}>{typeof betValue2 === "number" ? betValue2.toFixed(2) : betValue2}</span>
                                        <span className={'bet-control-currency'}>USD</span>
                                    </div>
                                </button>
                            </div>
                        </div>
                        <div className={`bet-controller-border-line ${autoBetController2 ? "" : "hidden"}`}></div>
                        <div className={`auto-bet-container ${autoBetController2 ? "" : "hidden"}`}>
                            <div className={'auto-bet-block'}>
                                <div className={'aut-bet-wrapper'}>
                                    Auto Bet
                                </div>
                                <div className={'um-switch'}>
                                    <div className={`um-input-switch ${autoBet2 ? "" : "off"}`} onClick={() => {
                                        setAutoBet2(prev => !prev);
                                    }}>
                                        <span className={'switch-oval'}></span>
                                    </div>
                                </div>
                            </div>
                            <div className={'cashout-block'}>
                                <div className={'cashout-switcher-wrapper'}>
                                    <div className={'auto-cashout-text'}>
                                        Auto Cash Out
                                    </div>
                                    <div className={'um-switch'}>
                                        <div className={`um-input-switch ${autoCashout2 ? "" : "off"}`} onClick={() => {
                                            setAutoCashout2(prev => !prev);
                                        }}>
                                            <span className={'switch-oval'}></span>
                                        </div>
                                    </div>
                                    <div className={'cashout-spinner-wrapper'}>
                                        <div className={'cashout-spinner'}>
                                            <div className={'cashout-input-wrapper'}>
                                                <input type={"text"} inputMode={'decimal'} disabled={""} value={"1.10"}/>
                                            </div>
                                            <span style={{
                                                padding: "0",
                                                fontSize: "16px",
                                                lineHeight: "1",
                                                color: "#fff",
                                                opacity: ".5",
                                                fontWeight: "700",
                                            }}>×</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                    </div>
                </div> */}

            
        </>
    )
}

export default BetControl2Hand;